// import { FileIcon } from "react-file-icon";
import { saveAs } from 'file-saver';
import pdf from '../assets/Thread/fileIcons/pdf.svg'
import excel from '../assets/Thread/fileIcons/excel.svg'
import doc from '../assets/Thread/fileIcons/doc.svg'
import ppt from '../assets/Thread/fileIcons/ppt.svg'
import img from '../assets/Thread/fileIcons/img.svg'
import zip from '../assets/Thread/fileIcons/zip.svg'
import txt from '../assets/Thread/fileIcons/txt.svg'
import download from '../assets/Thread/fileIcons/download.svg'
import remove_Icon from '../assets/Thread/fileIcons/close.svg'
import getFileNameFromUrl from '../utils/getFileNameFromUrl';
import { twMerge } from 'tailwind-merge';

const CustomFileIcon = ({
    extension,
    url,
    key = "",
    name="",
    downloadable=true,
    removeFile,
    className = "",
    contentClassName = ""
}) => {

    const fileIcons = {
        pdf: pdf,
        doc: doc,
        docx: doc,
        xls: excel,
        xlsx: excel,
        csv: excel,
        jpeg: img,
        jpg: img,
        png: img,
        txt: txt,
        zip: zip,
        rar: zip,
        "7z": zip,
    }

    const fileName = getFileNameFromUrl(url)
    const fileIcon = fileIcons[extension]

    return (
        <div 
          className={twMerge("flex min-w-[180px] max-w-[250px] items-center", className)}
          key={key}
				>
            <button
              className="min-w-[180px] max-w-[250px] cursor-default rounded-[8px] bg-[#EFEFEF]"
              title={`Download ${extension} file`} >
              <div className={twMerge("relative flex w-full min-w-[180px] max-w-[250px] gap-[5px] rounded-[5px] border-[1px] border-medium-gray p-1 sm:p-2", contentClassName)}>
                <img 
                  className="h-[20px] w-[20px] shrink-0 lg:h-[25px] lg:w-[25px]"
                  src={fileIcon}/>
                  <div className="flex min-w-0 flex-1 flex-col items-start gap-2 overflow-hidden leading-none">
                    <span className="w-full min-w-0 truncate text-left text-[0.5rem] sm:text-[0.6rem] md:text-[0.775rem] font-inter text-[#6D6D6D]"> { fileName || name} </span>
                    <span className="w-full min-w-0 before:content-['•'] before:mr-1 truncate text-left text-[0.45rem] sm:text-[0.5rem] md:text-[0.6rem] font-inter text-[#6D6D6D]">{extension}</span>
                  </div>
                {!downloadable && 
                    <div className="flex min-w-[20px] h-[20px] justify-center items-center rounded-[50%] bg-[#FFFFFF] ml-auto cursor-pointer">
											<img 
												className="w-[10px]" 
												src={remove_Icon}
												onClick={removeFile}
												/>
										</div>
										}
                {downloadable && 
                   <div 
                     onClick={(e) => {e.preventDefault(); downloadable && saveAs(url, fileName)}}
                     className="flex w-[12px] lg:w-[16px]  justify-center items-center cursor-pointer ml-auto flex-shrink-0">
                     <img 
                       className="w-full h-full" 
                       src={download}/>
                   </div>
                   }
               </div>
            </button>
        </div>
    );
};

export default CustomFileIcon;

